/* auto-fit: shrink the headline (then the message) until everything fits on the label */
window.AfFitLabel=window.AfFitLabel||function(label){
 try{
  if(!label) return; var st=label.querySelector('.li-stage'), band=label.querySelector('.li-band'), head=label.querySelector('.li-head'), msg=label.querySelector('.li-msg');
  if(!st||!band||!head) return;
  var un=[], n0=label; while(n0&&n0.nodeType===1){ if(getComputedStyle(n0).display==='none'){ un.push([n0,n0.style.cssText]); n0.style.setProperty('display','block','important'); n0.style.setProperty('visibility','hidden','important'); } n0=n0.parentElement; }
  try{ fitIn(); } finally { un.forEach(function(u){ u[0].style.cssText=u[1]; }); }
  function fitIn(){
  head.style.fontSize=''; if(msg) msg.style.fontSize=''; [].forEach.call(label.querySelectorAll('.th-pframe,.li-img'),function(e){ e.style.removeProperty('width'); if(e.classList.contains('th-pframe')) e.style.removeProperty('height'); });
  var cs=getComputedStyle(st), pf=function(v){ return parseFloat(v)||0; };
  var aH=st.clientHeight-pf(cs.paddingTop)-pf(cs.paddingBottom), aW=st.clientWidth-pf(cs.paddingLeft)-pf(cs.paddingRight);
  if(aH<=0||aW<=0) return;
  var foot=label.querySelector('.li-footer'), pic=label.classList.contains('has-img')?(label.querySelector('.th-pframe')||label.querySelector('.li-img')):null;
  function lastBottom(){ var el=(msg&&msg.style.display!=='none'&&msg.textContent.trim())?msg:band; return el.getBoundingClientRect().bottom; }
  function limit(){ var sb=st.getBoundingClientRect(), k=(sb.height/(st.offsetHeight||1))||1, L=sb.bottom-pf(cs.paddingBottom)*k; if(foot&&foot.offsetHeight){ var fb=foot.getBoundingClientRect(); if(fb.height>0) L=Math.min(L,fb.top-6*k); } return L; }
  function lines(){ var hc=getComputedStyle(head), lh=parseFloat(hc.lineHeight); if(!lh||isNaN(lh)) lh=(parseFloat(hc.fontSize)||1)*1.05; return Math.round(head.offsetHeight/lh); }
  function over(){ if(pic&&lines()>2) return true; if(lastBottom()>limit()+1) return true; if(band.offsetHeight>aH+1) return true; if(head.scrollWidth>aW+1) return true; var k=head.children; for(var i=0;i<k.length;i++){ if(k[i].scrollWidth>aW+1) return true; } return false; }
  if(!over()) return;
  var h0=pf(getComputedStyle(head).fontSize), m0=msg&&msg.style.display!=='none'?pf(getComputedStyle(msg).fontSize):0, f=1, n=0;
  while(over()&&f>0.3&&n++<50){ f*=0.95; head.style.fontSize=(h0*f).toFixed(1)+'px'; }
  if(pic&&over()){ var kk=(st.getBoundingClientRect().width/(st.offsetWidth||1))||1, w0=pic.getBoundingClientRect().width/kk, p=1; n=0; while(over()&&p>0.6&&n++<20){ p*=0.95; pic.style.setProperty('width',(w0*p).toFixed(0)+'px','important'); if(pic.classList.contains('th-pframe')) pic.style.setProperty('height','auto','important'); } }
  /* the line underneath keeps its size; only as a very last resort does it shrink a touch */
  if(m0){ var g=1; n=0; while(over()&&g>0.85&&n++<20){ g*=0.95; msg.style.fontSize=(m0*g).toFixed(1)+'px'; } }
  }
 }catch(e){}
};
/* Afterlights — live label wrap (progressive enhancement)
   Rasterizes the live DOM label and composites it onto the candle photo via
   WrapEngine. If anything it needs is missing (no canvas, html2canvas blocked,
   a render throws) it calls opts.onFallback() and the caller shows the existing
   flat label overlay instead. Never throws upward.

   LabelWrap.create({ photoSrc, baseCanvas, wrapCanvas, labelEl, settings,
                      onReady, onFallback })  -> { update(), destroy(), ok }
*/
(function(){
  var H2C_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js';
  var SYM_MASKS = { 'm-dove':'assets/icons/dove-wing.png', 'm-olive':'assets/icons/olive-branch.png' };

  function canvasOK(){
    try { var c=document.createElement('canvas'); return !!(c.getContext && c.getContext('2d')); }
    catch(e){ return false; }
  }
  function loadH2C(){
    if(window.html2canvas) return Promise.resolve(window.html2canvas);
    return new Promise(function(res,rej){
      var s=document.createElement('script'); s.src=H2C_SRC;
      s.onload=function(){ window.html2canvas ? res(window.html2canvas) : rej(); };
      s.onerror=rej; document.head.appendChild(s);
    });
  }
  // In the html2canvas clone, swap CSS-mask symbol spans (which h2c can't paint)
  // for ink-tinted raster <img>s so dove/olive symbols survive into the raster.
  // Mask PNGs are loaded through a blob URL so the tint canvas is never tainted
  // (a tainted toDataURL throws, which used to blank the symbol entirely).
  var MASK_CACHE = {};
  function loadMask(url){
    if(MASK_CACHE[url]) return MASK_CACHE[url];
    var p = fetch(url, {mode:'cors', credentials:'omit'})
      .then(function(r){ if(!r.ok) throw new Error('mask '+r.status); return r.blob(); })
      .then(function(blob){
        return new Promise(function(res,rej){
          var u=URL.createObjectURL(blob), im=new Image();
          im.onload=function(){ res(im); };
          im.onerror=function(){ URL.revokeObjectURL(u); rej(new Error('mask decode')); };
          im.src=u;
        });
      })
      .catch(function(){
        // last resort: plain same-origin <img> (works when fetch is blocked but the
        // image is genuinely same-origin, so the canvas stays clean)
        return new Promise(function(res,rej){
          var im=new Image();
          im.onload=function(){ res(im); };
          im.onerror=function(){ rej(new Error('mask load')); };
          im.src=url;
        });
      });
    MASK_CACHE[url]=p;
    return p;
  }

  // Sizes are measured in the LIVE document, and each mask is tinted to a data URL
  // BEFORE html2canvas runs — the onclone swap must be synchronous, because h2c does
  // not wait for an async onclone to finish before it captures.
  function prepareSymbols(labelEl, masks, inkHex){
    var spans=labelEl.querySelectorAll('.sym-mask');
    if(!spans.length) return Promise.resolve([]);
    return Promise.all(Array.prototype.map.call(spans, function(span,i){
      var cs=getComputedStyle(span);
      // NB: scan class tokens, never a regex over the whole class string — /m-[a-z0-9_-]+/
      // on "sym-mask m-dove" matches "m-mask" first, so the mask URL is never found and
      // the raw span survives into the raster as a solid background:currentColor box.
      var url=null;
      for(var t=0;t<span.classList.length;t++){
        var cls=span.classList[t];
        if(cls.indexOf('m-')===0 && masks[cls]){ url=masks[cls]; break; }
      }
      var key='lws'+i; span.setAttribute('data-lw-sym',key);
      var w=parseFloat(cs.width)||120, h=parseFloat(cs.height)||120;
      if(!url) return {key:key,w:w,h:h,data:null};
      return loadMask(url).then(function(im){
        var c=document.createElement('canvas'); c.width=Math.round(w*2); c.height=Math.round(h*2);
        var x=c.getContext('2d');
        var sc=Math.min(c.width/im.width,c.height/im.height), dw=im.width*sc, dh=im.height*sc;
        x.drawImage(im,(c.width-dw)/2,(c.height-dh)/2,dw,dh);
        x.globalCompositeOperation='source-in'; x.fillStyle=inkHex||'#241F18'; x.fillRect(0,0,c.width,c.height);
        return {key:key,w:w,h:h,data:c.toDataURL('image/png')};
      }).catch(function(){ return {key:key,w:w,h:h,data:null}; });
    }));
  }

  // html2canvas ignores object-fit/object-position, so a cover-cropped photo
  // (and its face-centred position) paints stretched and uncropped. Record the
  // computed crop up front, then replay it as a background-image in the clone.
  var LW_PX='data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
  function tagCoverImages(labelEl){
    var recs=[], imgs=labelEl.querySelectorAll('img');
    for(var i=0;i<imgs.length;i++){
      var im=imgs[i], cs=getComputedStyle(im), fit=cs.objectFit;
      if(fit!=='cover' && fit!=='contain') continue;
      var src=im.currentSrc||im.src;
      if(!src || src===LW_PX) continue;
      var key='lwi'+i; im.setAttribute('data-lw-img',key);
      recs.push({key:key, src:src, fit:fit, pos:cs.objectPosition||'50% 50%'});
    }
    return recs;
  }
  // Rather than mutating html2canvas's clone (whose onclone timing and document
  // identity are fragile), swap the real elements just before capture and restore
  // straight after. In candle view the DOM label is invisible, so nothing flickers.
  function applyForCapture(labelEl, symRecs, imgRecs){
    var undo=[];
    symRecs.forEach(function(rc){
      if(!rc.data) return;
      var span=labelEl.querySelector('[data-lw-sym="'+rc.key+'"]');
      if(!span || !span.parentNode) return;
      var rep=document.createElement('img');
      rep.src=rc.data;
      rep.style.cssText='display:block;width:'+rc.w+'px;height:'+rc.h+'px;margin:0 auto';
      var parent=span.parentNode;
      parent.replaceChild(rep, span);
      undo.push(function(){ if(rep.parentNode) rep.parentNode.replaceChild(span, rep); });
    });
    imgRecs.forEach(function(rc){
      var el=labelEl.querySelector('[data-lw-img="'+rc.key+'"]');
      if(!el) return;
      var prevStyle=el.getAttribute('style'), prevSrc=el.getAttribute('src');
      el.style.backgroundImage='url("'+rc.src.replace(/"/g,'\\"')+'")';
      el.style.backgroundSize=rc.fit;
      el.style.backgroundPosition=rc.pos;
      el.style.backgroundRepeat='no-repeat';
      el.setAttribute('src', LW_PX);
      undo.push(function(){
        if(prevStyle==null) el.removeAttribute('style'); else el.setAttribute('style', prevStyle);
        if(prevSrc!=null) el.setAttribute('src', prevSrc);
      });
    });
    return function(){ for(var i=undo.length-1;i>=0;i--){ try{ undo[i](); }catch(e){} } };
  }

  // The label often sits inside a transform:scale() mount (candle preview). html2canvas
  // renders the *scaled* box but is told to output at offsetWidth, which paints the label
  // tiny in the top-left of the raster. Strip transforms from the clone so it lays out 1:1.
  var LW_UID = 0;

  /* ONE render at a time across every preview on the page. html2canvas clones the whole
     document for each capture; several running at once (hero + designs + scenes + gallery)
     is what pushed phones past their memory limit. */
  var RQ=[], rqBusy=false;
  function enqueue(job){ RQ.push(job); pump(); }
  function pump(){
    if(rqBusy||!RQ.length) return; rqBusy=true;
    var job=RQ.shift(), fin=false, guard=setTimeout(release, 15000);
    function release(){ if(fin) return; fin=true; clearTimeout(guard); rqBusy=false; setTimeout(pump, 30); }
    try{ job(release); }catch(e){ release(); }
  }
  /* identical labels (same design, size, paper) are rasterized once and reused by every scene */
  var LC=[];
  function labelKey(label, bg){
    var imgs=label.querySelectorAll('img'); for(var i=0;i<imgs.length;i++){ if(!imgs[i].complete) return null; }
    var host=label.closest?label.closest('.pzr'):null;
    return label.outerHTML.replace(/ data-lw-[a-z]+="[^"]*"/g,'')+'|'+label.offsetWidth+'x'+label.offsetHeight+'|'+bg+'|'+getComputedStyle(label).color+'|'+(host?host.className.replace(/\b(wrap-\w+|loading)\b/g,''):'');
  }
  function lcGet(k){ if(!k) return null; for(var i=0;i<LC.length;i++) if(LC[i].k===k) return LC[i].c; return null; }
  function lcPut(k,c){ if(!k) return; LC.push({k:k,c:c}); while(LC.length>4){ var o=LC.shift(); if(o.c!==c){ o.c.width=o.c.height=0; } } }
  function unscaleInClone(clonedDoc, labelEl){
    try{
      var id = labelEl.getAttribute('data-lw-id');
      var el = id && clonedDoc.querySelector('[data-lw-id="'+id+'"]');
      if(!el) return;
      el.style.transform='none';
      el.style.zoom='1';
      var n = el.parentNode;
      while(n && n.nodeType===1 && n.tagName!=='BODY' && n.tagName!=='HTML'){
        n.style.transform='none';
        n.style.zoom='1';
        n = n.parentNode;
      }
    }catch(e){}
  }

  function create(opts){
    var api={ ok:false, update:function(){}, destroy:function(){} };
    if(!canvasOK() || !window.WrapEngine){ opts.onFallback && opts.onFallback('no-canvas'); return api; }
    var SYM = opts.symMasks || SYM_MASKS;

    var pending=false, queued=false, dead=false, firstPaint=true, isBusy=false;
    function busy(b){ if(isBusy===b) return; isBusy=b; opts.onBusy && opts.onBusy(b); }
    var h2c=null, everPainted=false;

    function doRender(){
      if(dead) return;
      pending=true;
      enqueue(function(release){
        if(dead){ pending=false; release(); return; }
        var label=opts.labelEl;
        if(!label.offsetWidth || !label.offsetHeight){
          // hidden / not laid out yet — poll cheaply until it's visible, then paint.
          pending=false; release();
          if(!everPainted){ if(t) clearTimeout(t); t=setTimeout(doRender, 400); }
          return;
        }
        var bg=(opts.settings&&opts.settings.paper==='clear')?null:'#ffffff';
        function paint(labelCanvas){
          if(dead){ release(); return; }
          try { WrapEngine.render(opts.baseCanvas, opts.wrapCanvas, labelCanvas, opts.settings); }
          catch(e){ release(); fail('render-throw'); return; }
          everPainted=true; pending=false; release();
          if(firstPaint){ firstPaint=false; opts.onFirstPaint && opts.onFirstPaint(); }
          if(queued){ queued=false; schedule(0); } else { busy(false); }
        }
        var key=labelKey(label, bg), hit=lcGet(key);
        if(hit){ paint(hit); return; }
        var inkHex=getComputedStyle(label).color;
        if(!label.getAttribute('data-lw-id')) label.setAttribute('data-lw-id','lw'+(++LW_UID));
        var imgRecs=tagCoverImages(label);
        prepareSymbols(label, SYM, inkHex).then(function(symRecs){
          if(window.AfFitLabel) AfFitLabel(label); var restore=applyForCapture(label, symRecs, imgRecs);
          h2c(label, {
            backgroundColor:bg, scale:1, useCORS:true, logging:false,
            width:label.offsetWidth, height:label.offsetHeight,
            onclone:function(doc){ unscaleInClone(doc, label); }
          }).then(function(labelCanvas){
            restore(); lcPut(key, labelCanvas); paint(labelCanvas);
          }).catch(function(){ restore(); release(); fail('h2c-throw'); });
        }).catch(function(){ release(); fail('sym-throw'); });
      });
    }

    var t=null;
    function schedule(delay){
      if(dead) return;
      busy(true);
      if(pending){ queued=true; return; }
      if(t) clearTimeout(t);
      t=setTimeout(doRender, delay==null?180:delay);
    }
    function fail(why){ if(dead) return; dead=true; busy(false); opts.onFallback && opts.onFallback(why); }

    // boot: load base photo into WrapEngine, then html2canvas
    WrapEngine.loadBase(opts.photoSrc, opts.baseCanvas, function(err){
      if(err){ fail('base-load'); return; }
      loadH2C().then(function(fn){
        if(dead) return;
        h2c=fn; api.ok=true;
        opts.onReady && opts.onReady();
        schedule(0);
      }).catch(function(){ fail('h2c-load'); });
    });

    api.update=function(immediate){ schedule(immediate?0:180); };
    api.ready=function(){ return api.ok && !dead; };
    api.setScene=function(src, settings){
      if(dead) return;
      if(settings) opts.settings=settings;
      WrapEngine.loadBase(src, opts.baseCanvas, function(err){ if(err){ fail('scene-load'); return; } schedule(0); });
    };
    api.destroy=function(){ dead=true; if(t) clearTimeout(t); };
    return api;
  }

  /* flat print capture: the label element → high-res PNG canvas (no wrap, no photo) */
  function capture(label, o){
    o=o||{}; var SYM=o.symMasks||SYM_MASKS;
    return loadH2C().then(function(h2c){
      if(!label.getAttribute('data-lw-id')) label.setAttribute('data-lw-id','lw'+(++LW_UID));
      var inkHex=getComputedStyle(label).color, imgRecs=tagCoverImages(label);
      return prepareSymbols(label, SYM, inkHex).then(function(symRecs){
        if(window.AfFitLabel) AfFitLabel(label); var restore=applyForCapture(label, symRecs, imgRecs);
        return h2c(label,{ backgroundColor:o.transparent?null:'#ffffff', scale:o.scale||2, useCORS:true, logging:false,
          width:label.offsetWidth, height:label.offsetHeight, onclone:function(doc){ unscaleInClone(doc, label); } })
          .then(function(c){ restore(); return c; }, function(e){ restore(); throw e; });
      });
    });
  }
  window.LabelWrap = { create:create, capture:capture };
})();
